import { FC } from 'react'
import cn from 'classnames'
import { Link } from 'components/ui'
import s from './slider.module.css'
import type { SlideProps } from '.'

const Slide: FC<SlideProps> = ({ children, className, ...rest }) => {
  return (
    <Link {...rest} className={cn(s.slide, className)}>
      {children}
    </Link>
  )
}

export default Slide
